import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function FmexDatingSection() {
  // cards are full-image assets (contain text + art inside the image)
  const cards = [
    { id: 1, img: "/images/appfeatures1.webp" },
    { id: 2, img: "/images/appfeatures2.webp" },
    { id: 0, img: "/images/appfeatures3.webp" },
  ];

  const [index, setIndex] = useState(0);
  const [dir, setDir] = useState(0); // -1 left, +1 right

  const prevCard = () => {
    setDir(-1);
    setIndex((i) => (i - 1 + cards.length) % cards.length);
  };

  const nextCard = () => {
    setDir(1);
    setIndex((i) => (i + 1) % cards.length);
  };

  // motion variants for sliding left/right
  const variants = {
    enter: (direction) => ({
      x: direction > 0 ? 300 : -300,
      opacity: 0,
      scale: 0.98,
    }),
    center: {
      x: 0,
      opacity: 1,
      scale: 1,
    },
    exit: (direction) => ({
      x: direction > 0 ? -300 : 300,
      opacity: 0,
      scale: 0.98,
    }),
  };

  return (
    <section id="fmexapp" className="relative w-full min-h-screen overflow-hidden bg-gradient-to-br from-[#ff7b5d] via-[#ff5db1] to-[#ff9f5d] px-6 py-20 md:px-16">
      <div className="max-w-7xl mx-auto">
        {/* Layout wrapper: desktop is row (phone left, content right), mobile is column */}
        <div className="flex flex-col md:flex-row items-start md:items-center gap-10">
          {/* PHONE (desktop-only left) */}
          <div className="hidden md:flex md:w-[45%] justify-center md:justify-start">
            <img
              src="/images/appui.webp"
              alt="phone"
              className="w-[390px] drop-shadow-2xl"
            />
          </div>

          {/* RIGHT SIDE (header, description, mobile phone, card slider) */}
          <div className="w-full md:w-[55%]">
            {/* Header */}
            <div className="flex items-start gap-4">
              <h1 className="text-white font-extrabold text-2xl md:text-3xl tracking-wide">
                FMEX APP
                <span className="ml-3 bg-white text-[#ff5db1] text-[10px] md:text-xs px-3 py-0 md:py-1 rounded-md font-semibold">
                  COMING SOON
                </span>
              </h1>
            </div>

            {/* Big title (desktop size same as before) */}
            <h2 className="text-black font-extrabold mt-6 text-[34px] md:text-[40px] leading-tight">
              COMMIT. CONNECT.
              <br />
              PROGRESS.
              <br />
              
            </h2>

            {/* Description */}
            <p className="text-black/90 mt-6 leading-relaxed max-w-lg text-[15px]">
              Introducing the FMEX App, a social growth platform designed to connect individuals through shared experiences, 
              aligned behavior, and long-term ambition (“1000x energy”).
              Rather than relying on attention-driven social mechanics, the platform prioritizes intentional connection, 
              accountability, and measurable progress both individually and within small, aligned groups.
            </p>

            {/* PHONE (mobile-only between description & card) */}
            <div className="mt-6 md:hidden flex justify-center">
              <img
                src="/images/appui.webp"
                alt="phone mobile"
                className="w-[260px] drop-shadow-2xl"
              />
            </div>

            {/* CARD SLIDER */}
            <div className="mt-6">
            <div className="relative w-full flex items-left justify-left overflow-hidden">
            <AnimatePresence custom={dir} initial={false}>
              <motion.img
                key={cards[index].id}
                        src={cards[index].img}
                custom={dir}
                variants={variants}
                initial="enter"
                animate="center"
                exit="exit"
                transition={{ duration: 0.36, ease: "easeInOut" }}
                alt={`card-${index}`}
                className="w-full max-w-[650px] object-contain pointer-events-none select-none"
              />
            </AnimatePresence>
          </div>

              {/* arrows (mobile & desktop same area) */}
              <div className="flex items-center justify-center gap-10 mt-6">
                <button
                  onClick={prevCard}
                  aria-label="Previous card"
                  className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-white/90 border-2 border-black flex items-center justify-center shadow-md active:scale-95"
                >
                  <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none">
                    <path d="M15 18l-6-6 6-6" stroke="#111" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </button>

                <button
                  onClick={nextCard}
                  aria-label="Next card"
                  className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-white/90 border-2 border-black flex items-center justify-center shadow-md active:scale-95"
                >
                  <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none">
                    <path d="M9 6l6 6-6 6" stroke="#111" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
